import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../../styles/profesional/home.css';
import * as globals from './../../components/GlobalScripts.js';
import Rating from './../rating/Rating';

const Profesional_home = () => {
    let path_api = localStorage.getItem('path_api');
    const [user, setUser] = useState([]);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);
            setUser(userParsed);
        }
    }, []);

    const getNextWednesday = () => {
        const today = new Date();
        const currentDay = today.getDay();
        let daysToAdd;
        if (currentDay <= 3) {
            daysToAdd = 3 - currentDay;
        } else {
            daysToAdd = 7 - (currentDay - 3);
        }
        const nextWed = new Date(today);
        nextWed.setDate(today.getDate() + daysToAdd);
        return nextWed;
    };

    const formatDate = (date) => {
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        let yy = date.getFullYear().toString().slice(-2);
        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;
        return `${dd}/${mm}/${yy}`;
    };

    const nextWednesdayFormatted = formatDate(getNextWednesday());

    const relevantReviews = user?.reviews?.filter(
        review => review.recieved === user?.keylogin && review.type === "cliente"
    ) || [];

    const averageRating =
        relevantReviews.length > 0
            ? relevantReviews.reduce((sum, review) => sum + Number(review.rating), 0) / relevantReviews.length
            : 0;

    return (
        <>
            <div className='container-profesional page-home container-section'>
                <div className='left-side'>
                    <div className="profile-name">
                        <img src={path_api + (user?.img_profile != "/images/profile_default.png"? user?.account?.img_profile: user?.img_profile)}></img>
                        <div className='flex-column gap-5'>
                            <h5>{user?.account?.nombre + ' ' + user?.account?.apellidos}</h5>
                            {/* {user?.img_profile == '/images/profile_default.png' && (  
                                <Link to="/profesional/cuenta" className='text-red'>Sube tu imagen de perfil para recibir pagos</Link>
                            )} */}
                            <Rating rating={averageRating} size={20} />
                            <p>
                                <b>Proyectos: </b>
                                {user?.proposal_active
                                    ? user.proposal_active.filter(project => project.recieved === user?.keylogin).length
                                    : 0} en curso
                            </p>
                            <Link to="/profesional/cuenta" className='margin-top'><b>Editar perfil</b></Link>
                        </div>
                    </div>

                    <div>
                        <h5>Tu saldo disponible</h5>
                        {(!user?.profile?.identificacionFrontal_rute || !user?.profile?.identificacionTrasera_rute) && (
                            <Link to="/profesional/perfil" className='text-red'>Sube tu identificación para recibir pagos</Link>
                        )}
                        <div className='space-between'>
                            <p><b>Fecha:</b></p>
                            <p>{nextWednesdayFormatted}</p>
                        </div>
                        <div className='space-between'>
                            <p><b>Método de pago:</b></p>
                            {user?.payment_method?.tipo && (
                                <p>{user?.payment_method?.tipo}</p>
                            )}
                            {!user?.payment_method?.tipo && (
                                <Link to="/profesional/metodo-de-pago" className='text-red'><b>Agrega un método</b></Link>
                            )}
                        </div>
                        <div className='space-between'>
                            <p><b>Disponible para retirar:</b></p>
                            <p>${user?.balance} MXN</p>
                        </div>
                    </div>

                    <div>
                        <h5>Proyectos</h5>
                        <div className='space-between'>
                            <p><b>Membresia:</b></p>
                            {user?.membership?.membership_info?.descripcion && (
                                <p>{user?.membership?.membership_info?.descripcion}</p>
                            )}
                            {!user?.membership?.membership_info?.descripcion && (
                                <p className='text-red'>Error</p>
                            )}
                        </div>
                        <div className='space-between'>
                            <p><b>Limite semanal:</b></p>
                            {user?.membership?.membership_info?.proyects_limit && (
                                <p>{user?.membership?.membership_info?.proyects_limit}</p>
                            )}
                            {!user?.membership?.membership_info?.proyects_limit && (
                                <p className='text-red'>Error</p>
                            )}
                        </div>
                        <div className='space-between'>
                            <p><b>En los últimos 7 días:</b></p>
                            <p>
                                {user?.proposal
                                    ? user.proposal.filter(project => project.estado === "finalizada" && project.recieved === user?.keylogin).length
                                    : 0}
                            </p>
                        </div>


                        <div className='space-between'>
                            <p><b>Restantes:</b></p>
                            <p>
                                {
                                    user?.membership?.membership_info?.proyects_limit
                                        ? Math.max(
                                            Number(user.membership.membership_info.proyects_limit) -
                                            (user?.proposal ? user.proposal.filter(project => project.estado === "finalizada" && project.recieved === user?.keylogin).length : 0),
                                            0
                                        )
                                        : "-"
                                }
                            </p>
                        </div>

                    </div>
                </div>
                <div className="right-side">
                    <div className='flex-column gap-10'>
                        <h4>Proyectos en los que estas trabajando</h4>
                        <div className="projects">
                            {user?.proposal_active &&
                                user.proposal_active.filter(project => project.recieved === user?.keylogin).length > 0 ? (
                                user.proposal_active
                                    .filter(project => project.recieved === user?.keylogin)
                                    .map((project, index) => (
                                        <div key={index} className="project-item">
                                            <h4>Titulo</h4>
                                            <h5>{project.titulo}</h5>
                                            <h4 className='margin-top-15'>Descripción</h4>
                                            <p>{project.descripcion}</p>
                                            <p className='margin-top-15'>Costo: ${project.precio} MXN</p>
                                            <Link to={`/chat/${project.sender}/`}>Ver proyecto</Link>
                                        </div>
                                    ))
                            ) : (
                                <h5>De momento no tienes proyectos en curso.</h5>
                            )}
                        </div>
                    </div>

                    <div className='flex-column gap-10'>
                        <h4>Últimos proyectos finalizados (7 dias)</h4>
                        <div className="projects">
                            {user?.proposal &&
                                user.proposal.filter(project => project.estado === "finalizada" && project.recieved === user?.keylogin).length > 0 ? (
                                user.proposal
                                    .filter(project => project.estado === "finalizada" && project.recieved === user?.keylogin)
                                    .map((project, index) => (
                                        <div key={index} className="project-item">
                                            <h4>Título</h4>
                                            <h5>{project.titulo}</h5>
                                            <h4 className='margin-top-15'>Descripción</h4>
                                            <p>{project.descripcion}</p>
                                            <p className='margin-top-15'>Costo: ${project.precio} MXN</p>
                                            <Link to={`/chat/${project.sender}/`}>Ver chat</Link>
                                        </div>
                                    ))
                            ) : (
                                <h5>De momento no tienes proyectos finalizados.</h5>
                            )}
                        </div>
                    </div>

                    <div className='flex-column gap-10'>
                        <h4>Últimas propuestas recibidas (7 dias)</h4>
                        <div className="projects">
                            {user?.proposal && user.proposal.filter(project => project.estado !== "finalizada" && project.recieved === user?.keylogin).length > 0 ? (
                                user.proposal
                                    .filter(project => project.estado !== "finalizada" && project.recieved === user?.keylogin)
                                    .map((project, index) => (
                                        <div key={index} className="project-item">
                                            <h4>Título</h4>
                                            <h5>{project.titulo}</h5>
                                            <h4 className='margin-top-15'>Descripción</h4>
                                            <p>{project.descripcion}</p>
                                            <p className='margin-top-15'>Oferta por: ${project.precio} MXN</p>
                                            <p>Estado: {project.estado}</p>
                                            <Link to={`/chat/${project.sender}/`}>Ver chat</Link>
                                        </div>
                                    ))
                            ) : (
                                <h5>Aún no has recibido propuestas.</h5>
                            )}
                        </div>
                    </div>

                    <div className='flex-column gap-10'>
                        <div className='flex-row gap-10 center2'>
                            <h4>Portafolio</h4>
                            <Link to="/profesional/portafolio"><b>Editar portafolio</b></Link>
                        </div>
                        <div className="portafolio-list">
                            {user.portfolio && user.portfolio.length > 0 ? (
                                user.portfolio.map((portfolio, index) => (
                                    <div key={index} className="portafolio-item">
                                        <h3>{portfolio?.titulo}</h3>
                                        <p>{portfolio?.descripcion}</p>
                                        {portfolio.imagenes && portfolio.imagenes.length > 0 && (
                                            <div className="portfolio-images">
                                                {portfolio.imagenes.map((img, i) => (
                                                    <div className="image" key={i}>
                                                        <Link to={path_api + img.ruta} target='_blank'>
                                                            <img src={path_api + img.ruta} alt={`Imagen ${i + 1}`} />
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <h5>No tienes proyectos para mostrar.</h5>
                            )}
                        </div>
                    </div>

                    <div className='flex-column gap-10'>
                        {(() => {
                            const professionalReviews =
                                user?.reviews?.filter(
                                    review =>
                                        review.recieved === user?.keylogin && review.type === "cliente"
                                ) || [];
                            return (
                                <>
                                    <h4>Calificaciones de clientes ({professionalReviews.length})</h4>
                                    <div className="reviews">
                                        {professionalReviews.length > 0 ? (
                                            professionalReviews.map((review, index) => (
                                                <div key={index} className="review-item">
                                                    <div className="flex-row gap-20">
                                                        <img src={path_api + review.review_img_profile}></img>
                                                        <div className='flex-column gap-10'>
                                                            <h5>{review.review_nombre}</h5>
                                                            <Rating rating={review.rating} size={20} />
                                                            <p>{review.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <h5>No tienes reseñas para mostrar</h5>
                                        )}
                                    </div>
                                </>
                            );
                        })()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Profesional_home;